import { render, staticRenderFns } from "./dynamicLink.vue?vue&type=template&id=67a69042&"
import script from "./dynamicLink.vue?vue&type=script&lang=js&"
export * from "./dynamicLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports